import React from 'react';
import styled from 'styled-components';
import { Colors } from 'styles/Constants';

const OptionContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

const NewFeatureBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -5px;
  background-color: ${Colors.secondarySuccess};
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  z-index: 1;
  font-weight: bold;
  text-transform: uppercase;
`;

export const OptionWithBadge = ({
  children,
  isNewFeature
}: {
  children: React.ReactNode;
  isNewFeature?: boolean;
}) => (
  <OptionContainer>
    {children}
    {isNewFeature && <NewFeatureBadge>Nuevo</NewFeatureBadge>}
  </OptionContainer>
);
